import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Button, Form, Input, InputGroup, Table } from "reactstrap";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { t } from "i18next";

import { ITEMS_PER_PAGE, JobRole, USER_ROLE } from "../../constants";
import LocalstorageService from "../../helpers/localstorage-service";
import BankService from "../../services/bank";

import SortableHeader from "../../components/SortableHeader";
import NoRecords from "../../components/Table/NoRecords";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
// import ActionBtns from "../../components/ActionBtns";

import useListPage from "../../hooks/useListPage";

const HeaderList = [
  {
    title: t("BANK.NAME_LABEL"),
    value: "bankName",
    style: { minWidth: "150px", width: "30%" },
  },
  {
    title: t("BANK.NUMBER_LABEL"),
    value: "bankNumber",
    style: { minWidth: "150px", width: "30%" },
  },
];

function BankList() {
  const navigate = useNavigate();
  const [setPageTitle, setBreadcrumbItems] = useOutletContext();

  const [roleId, setRoleId] = useState(USER_ROLE.EMPLOYEE);

  const {
    list,
    isLoading,
    totalCount,
    currentPage,
    itemsPerPage,
    deleteModal,
    debouncedSearch,
    sortBy,
    handlePageClick,
    openDeleteModal,
    closeDeleteModal,
    confirmDelete,
  } = useListPage({
    service: BankService,
    listMethod: "listBanks",
    deleteMethod: "deleteBank",
    companyId: false,
    initialSort: null,
    initialPageSize: ITEMS_PER_PAGE,
    deleteIdField: "id",
  });

  useEffect(() => {
    setPageTitle(t("BANK.TITLE"));

    setBreadcrumbItems([
      { title: t("APPLICATION_TITLE"), link: "#" },
      { title: t("BANK.TITLE"), link: "#" },
    ]);

    const jobRole = LocalstorageService.getItem(JobRole);
    setRoleId(jobRole);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editFn = (item) => {
    navigate(`../update/${item.id}`);
  };

  const viewFn = (item) => {
    navigate(`../${item.id}/branches`, { state: { bankInfo: item } });
  };

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Form className="search-filter" onSubmit={(e) => e.preventDefault()}>
          <InputGroup>
            <Input
              onChange={debouncedSearch}
              placeholder={t("SEARCH")}
            />
            <Button color="primary" type="button">
              <i className="ri-search-line"></i>
            </Button>
          </InputGroup>
        </Form>

        {roleId === USER_ROLE.SUPER_ADMIN && (
          <Button
            color="primary"
            className="float-end"
            onClick={() => navigate("../add")}
          >
            <span className="d-none d-sm-block">{t("BANK.ADD_BANK")}</span>
            <i
              className="ri-add-line d-block d-sm-none"
              title={t("BANK.ADD_BANK")}
            ></i>
          </Button>
        )}
      </div>

      <Table striped bordered responsive size="sm">
        <thead>
          <tr>
            <SortableHeader
              headers={HeaderList}
              isDisabled={list.length === 0}
              sortClick={sortBy}
            />
            {roleId === USER_ROLE.SUPER_ADMIN && (
              <th style={{ width: "80px" }}></th>
            )}
          </tr>
        </thead>

        <tbody>
          {list.map((item, l0Idx) => (
            <tr key={l0Idx}>
              <td className="text-center">
                <div className="d-flex gap-1">
                  {roleId === USER_ROLE.SUPER_ADMIN && (
                    <Button
                      color="primary"
                      size="sm"
                      title={t("BANK.UPDATE_BANK")}
                      onClick={() => editFn(item)}
                    >
                      {t("UPDATE_TITLE")}
                    </Button>
                  )}
                  <Button
                    color="secondary"
                    size="sm"
                    title={t("BRANCH.VIEW_BRANCHES")}
                    onClick={() => viewFn(item)}
                  >
                    {t("BRANCH.TITLE") || "סניפים"}
                  </Button>
                </div>
              </td>
              <td>{item.bankName}</td>
              <td>{item.bankNumber}</td>
              {roleId === USER_ROLE.SUPER_ADMIN && (
                <td className="text-center">
                  <Button
                    color="danger"
                    size="sm"
                    title={t("BANK.DELETE_BANK")}
                    onClick={() => openDeleteModal(item)}
                  >
                    {t("DELETE_TITLE")}
                  </Button>
                </td>
              )}
            </tr>
          ))}

          {!isLoading && list.length === 0 && (
            <NoRecords colSpan={HeaderList.length + (roleId === USER_ROLE.SUPER_ADMIN ? 2 : 1)} />
          )}
        </tbody>
      </Table>

      <div className="custom-pagination mt-2">
        <PaginationControl
          page={currentPage}
          total={totalCount}
          limit={itemsPerPage}
          changePage={handlePageClick}
          next={true}
          last={true}
          ellipsis={1}
        />
      </div>

      <ConfirmDeleteModal
        isOpen={deleteModal.show}
        isLoading={isLoading}
        confirmFn={confirmDelete}
        cancelFn={closeDeleteModal}
      />
    </React.Fragment>
  );
}

export default BankList;
